export default __webpack_public_path__ + "static/media/sdogu3.06f37514.jpg";